import type { ChoiceType } from '~/model/ChoiceType';
import type { LocaleType } from '~/model/GlobalTypes';
import type { InteractionType } from '~/model/InteractionType';
import type { ProjectType } from '~/model/ProjectType';
import type { QuestionType } from '~/model/QuestionType';
import type { SectionType } from '~/model/SectionType';
import type { TranslationType } from '~/model/TranslationType';
import { defaultLocale } from '@/i18n/routing';
import { ComponentTranslationStatus } from '~/const/appConst';
import { AcceptLanguage, LocaleCode } from '~/const/locale';

export const getTranslationForUserLanguage = (
  translations: TranslationType,
  userLanguage: LocaleType,
  originalLocale: LocaleType = AcceptLanguage[defaultLocale],
) => {
  const status = translations?.[userLanguage]?.status;
  const enGBStatus = translations?.en_GB?.status;
  if (
    status === ComponentTranslationStatus.valid
    || status === ComponentTranslationStatus.auto
  ) {
    return translations[userLanguage];
  } else if (
    enGBStatus === ComponentTranslationStatus.valid
    || enGBStatus === ComponentTranslationStatus.auto
  ) {
    return translations.en_GB;
  }

  return translations?.[originalLocale];
};

export const getEntityTranslationVersion = ({
  entity,
  entityTranslated,
  isEnTranslationValid,
  originalLocale,
  userLanguage,
}: {
  entity: ProjectType | InteractionType | SectionType | QuestionType | ChoiceType;
  entityTranslated: boolean;
  isEnTranslationValid: boolean;
  originalLocale: LocaleType;
  userLanguage: LocaleType;
}) => {
  if (entityTranslated) {
    if (isEnTranslationValid)
      return entity?.translations?.en_GB;

    return entity?.translations?.[originalLocale];
  }
  return {
    ...(entity?.translations?.[userLanguage]
      || entity?.translations?.[originalLocale]),
    ...(entity?.media && { media: entity.media }),
  };
};

export const getLangAttributeValue = (
  originalLocale: LocaleType,
  locale: LocaleType,
  entityTranslated?: boolean,
) => {
  return (
    (!entityTranslated
      && originalLocale !== locale
      && `${LocaleCode[locale]}-x-mtfrom-${LocaleCode[originalLocale]}`)
    || null
  );
};
